import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames';
import useConfig from '../../../hooks/useConfig';
var defaultIcon = 'http://baleen-cdn-g.bybieyang.com/lego/img/img_titlebg%403x.png';
var cls = 'normal-title';
var NormalTitle = function NormalTitle(_ref) {
  var config = _ref.config,
    className = _ref.className,
    pid = _ref.pid,
    id = _ref.id;
  var title = config.title,
    titleIcon = config.titleIcon,
    textClor = config.textClor;
  var _useConfig = useConfig(),
    createNamespace = _useConfig.createNamespace,
    prefixCls = _useConfig.prefixCls;
  var classes = classnames(createNamespace === null || createNamespace === void 0 ? void 0 : createNamespace(cls, prefixCls), className);
  return _jsxs("div", Object.assign({
    className: classes,
    "data-pid": pid,
    "data-componentid": id
  }, {
    children: [_jsx("div", Object.assign({
      className: classnames(createNamespace === null || createNamespace === void 0 ? void 0 : createNamespace(cls + "-icon-left", prefixCls))
    }, {
      children: _jsx("img", {
        src: titleIcon || defaultIcon,
        alt: ""
      })
    })), _jsx("div", Object.assign({
      className: classnames(createNamespace === null || createNamespace === void 0 ? void 0 : createNamespace(cls + "-text", prefixCls)),
      style: {
        color: textClor === 'black' ? '#333' : '#fff'
      }
    }, {
      children: title
    })), _jsx("div", Object.assign({
      className: classnames(createNamespace === null || createNamespace === void 0 ? void 0 : createNamespace(cls + "-icon-right", prefixCls))
    }, {
      children: _jsx("img", {
        src: titleIcon || defaultIcon,
        alt: ""
      })
    }))]
  }));
};
NormalTitle.defaultProps = {
  config: {}
};
NormalTitle.displayName = 'NormalTitle';
export default NormalTitle;